import React, { useEffect, useContext, useState } from "react";
import { InputContainer } from "uikit-react";
import { Form, FormRow, FormInputWrapper } from "../../../ui";
import classnames from "classnames";

import UIkit from "uikit";
import { AppContexts } from "../../../providers";
import { OffCanvas } from "../../common/OffCanvas";

export default ({ data, onSuccess, onClose }) => {
  const { loading, createZone, editZone } = useContext(
    AppContexts.ZonesContext,
  );

  const [item, setItem] = useState(null);
  const [errors, setErrors] = useState([]);
  const [pending, setPending] = useState(false);

  useEffect(() => {
    if (!data) {
      setItem(null);
    } else {
      setItem({ ...data });
    }
  }, [data]);

  const update = (key, e) => {
    setItem({ ...item, [key]: e.target.value });
  };

  const validate = () => {
    const required = ["label", "description"];
    const errs = [];

    required.map((key) => {
      if (item[key].trim() === "") {
        errs.push(key);
      }
    });

    setErrors(errs);
    return errs;
  };

  const submit = async (e) => {
    e.preventDefault();

    let errs = validate();
    let msg = "";
    let status = "success";

    if (errs.length > 0) {
      return;
    }

    setPending(true);
    try {
      if (!!item.id) {
        await editZone(item);

        msg = "Item updated successfully";
        status = "success";
      } else {
        await createZone(item);

        msg = "Item created successfully";
        status = "success";
      }

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      msg = "Failed to Save";
      status = "danger";
    }

    UIkit.notification({
      message: msg,
      status: status,
    });

    setPending(false);
  };

  return (
    <OffCanvas open={!!item} close={onClose}>
      <div className="hms-modals-main hms-modals">
        <button
          className="uk-offcanvas-close uk-close-large"
          type="button"
          uk-close="true"
          onClick={onClose}
        />
        <div className="uk-modal-header">
          <h2 className="uk-modal-title">
            {item?.id ? "Update Zones" : "Add Zones"}
          </h2>
        </div>
        <div className="uk-modal-body uk-flex">
          <Form className="uk-grid-small" uk-grid="true" onSubmit={submit}>
            <FormRow>
              <FormInputWrapper label="Name*" size="two">
                <InputContainer>
                  <input
                    className={classnames("uk-input", {
                      error: errors.includes("label"),
                    })}
                    type="text"
                    placeholder=""
                    value={item?.label || ""}
                    onInput={(e) => {
                      update("label", e);
                    }}
                  />
                </InputContainer>
              </FormInputWrapper>
            </FormRow>

            <FormRow>
              <FormInputWrapper label="Description*" size="two">
                <InputContainer>
                  <textarea
                    className={classnames("uk-textarea", {
                      error: errors.includes("description"),
                    })}
                    placeholder=""
                    value={item?.description || ""}
                    rows="5"
                    onInput={(e) => {
                      update("description", e);
                    }}
                  ></textarea>
                </InputContainer>
              </FormInputWrapper>
            </FormRow>

            <div>
              <button
                className="uk-button hms-btn hms-red-btn"
                type="submit"
                disabled={pending}
              >
                {pending ? (
                  <>
                    <div uk-spinner="ratio: 0.6"></div>
                    {item?.id ? "Updating..." : "Adding..."}
                  </>
                ) : item?.id ? (
                  "Update"
                ) : (
                  "Add"
                )}
              </button>
              <button
                className="uk-button hms-btn uk-offcanvas-close"
                type="button"
                onClick={onClose}
              >
                Cancel
              </button>
            </div>
          </Form>
        </div>
      </div>
    </OffCanvas>
  );
};
